'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.accordion = twentyninetimes.accordion || function () {

	function init() {
		accordions();
	}

	function accordions() {
		let accordions = document.querySelectorAll('.js-accordion');

		if ( accordions ) {
			accordions.forEach(accordion => {
				var accordion_toggle 	= accordion.querySelector('.js-accordion-toggle'),
					accordion_content	= accordion.querySelector('.js-accordion-content');

				accordion_toggle.addEventListener('click', function(e) {
					e.stopPropagation();

					if ( !accordion.classList.contains('active') ) {
						accordion.classList.add('active');

						accordion_content.style.height = 'auto';
						var accordion_height = accordion_content.clientHeight;
						accordion_content.style.height = '0px';

						setTimeout(function () {
							accordion.classList.add('active');
							accordion_content.style.height = accordion_height + 'px';
						}, 10);

						// setTimeout(function() {
						// 	accordion_content.style.height = 'auto';
						// }, 500);

            if ( accordion.classList.contains('item-hibob-job') ) {
              // add url parameter to the url
              var url = window.location.href;
              // if has job parameter, replace it else add it
              if ( url.indexOf('?job') > -1 ) {
                var newUrl = url.replace(/(\?job=)(.*)/, '$1' + accordion.dataset.job);
              }
              else {
                var newUrl = url + '?job=' + accordion.dataset.job;
              }
              
              window.history.replaceState(null, '', newUrl);
            }
					} else {
						var accordion_height = accordion_content.clientHeight;
						accordion_content.style.height = accordion_height + 'px';

						setTimeout(function () {
							accordion_content.style.height = '0px';
							accordion.classList.remove('active');						
						}, 10);

            if ( accordion.classList.contains('item-hibob-job') ) {
              // if has job url parameter, remove it
              var url = window.location.href;
              var newUrl = url.split('?')[0];
              
              window.history.replaceState(null, '', newUrl);
            }
					}
				});
			});
		}
	}

	return {
		init : init
	};

}();